import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Inject, Injectable, Injector } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * This service provides a methods for working with DOM
 */
@Injectable()
export class DomService {
  constructor(
    @Inject(DOCUMENT) private document,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  /**
   * This method is used for appending component to body
   * @param component The component to append
   */
  appendToBody<T>(component: any): ComponentRef<T> {
    const componentRef = this.componentFactoryResolver.resolveComponentFactory<T>(component).create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    this.document.body.appendChild(domElem);
    return componentRef;
  }

  /**
   * This method is used for removing component from body
   * @param componentRef The component ref to remove
   */
  removeFromBody(componentRef: ComponentRef<unknown>): void {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }
}
